import { useEffect } from 'react';
import { AuctionsReport, AuctionsParams } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

type Options = {
  params: AuctionsParams;
};

export function useAuctions({ params }: Options) {
  const auctions = useAxios(
    (axios, signal, params: AuctionsParams) =>
      axios.request<AuctionsReport>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/auctions`,
        params,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    auctions.execute(params);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return auctions;
}

export type AuctionsRequest = ReturnType<typeof useAuctions>;
